'use client';

import styled from 'styled-components';

import Location from '@icons/Location.svg';
import Rating from '@icons/Rating.svg';
import { Spacers } from '@styles/theme';

export const SchoolCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacers.BASE}rem;
  padding: ${Spacers.XS}rem;
  background-color: ${({ theme }) => theme.colors.backgroundLight};
  border: 1px solid ${({ theme }) => theme.colors.backgroundAccent};
  border-radius: ${Spacers.XS}rem;
  width: 100%;
`;

export const ImagePlaceholder = styled.div`
  width: 100%;
  height: 12.125rem;
  background-color: ${({ theme }) => theme.colors.backgroundAccent};
  border-radius: ${Spacers.XS}rem;
`;

export const SchoolImage = styled.img`
  width: 100%;
  height: 12.125rem;
  object-fit: cover;
  border-radius: ${Spacers.XS}rem;
`;

export const SchoolInfo = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
  gap: ${Spacers.XS}rem;
  padding-bottom: ${Spacers.XS}rem;
`;

export const SchoolName = styled.h3`
  font-size: ${({ theme }) => theme.typography.title.fontSize};
  color: ${({ theme }) => theme.colors.typographyHeadersLight};
  font-weight: ${({ theme }) => theme.typography.title.fontWeight};
  line-height: ${({ theme }) => theme.typography.title.lineHeight};
  margin: 0;
`;

export const AddressContainer = styled.div`
  display: flex;
  gap: ${Spacers.XS}rem;
`;

export const AddressText = styled.span`
  font-size: ${({ theme }) => theme.typography.body.fontSize};
  color: ${({ theme }) => theme.colors.typographyBodyLight};
  font-weight: ${({ theme }) => theme.typography.body.fontWeight};
  line-height: ${({ theme }) => theme.typography.body.lineHeight};
`;

export const ReviewContainer = styled.div`
  display: flex;
  gap: ${Spacers.XS}rem;
  & svg {
    width: ${Spacers.LG}rem;
    height: ${Spacers.LG}rem;
  }
`;

export const ReviewText = styled.span`
  font-size: ${({ theme }) => theme.typography.body.fontSize};
  color: ${({ theme }) => theme.colors.typographyBodyLight};
  font-weight: ${({ theme }) => theme.typography.body.fontWeight};
  line-height: ${({ theme }) => theme.typography.body.lineHeight};
`;

export const StyledRating = styled(Rating)`
  & path {
    stroke: ${({ theme }) => theme.colors.typographyBodyLight};
  }
`;

export const StyledLocation = styled(Location)`
  & path {
    fill: ${({ theme }) => theme.colors.typographyBodyLight};
  }
`;
